// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00fe5d31","455":"c2f886c8","977":"3c19e4b2"}[chunkId] + ".chunk.js";
};